import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about">
      <p className="section__text__p1 outfit-semibold">Get To Know More</p>
      <h1 className="title playfair-display-bold">About Me</h1>
      <div className="section-container">
        <div className="about-details-container">
          <div className="text-container-main">
            <p className="outfit-regular about-intro">
              Hello! I'm <span className="highlight">Prakash Choudhary</span>, a passionate Full Stack Developer and Machine Learning Engineer 
              based in Bikaner, Rajasthan. Currently pursuing B.Tech in Computer Science at Government Engineering College Bikaner, 
              I'm on a mission to create innovative solutions that bridge the gap between technology and real-world problems.
            </p>
            <p className="outfit-regular about-intro">
              As the <span className="highlight">CEO & Founder of Trivana Hospitality</span>, I've learned the art of combining technical expertise 
              with business acumen. My journey spans from building scalable web applications with modern technologies to developing 
              intelligent ML solutions that make a difference.
            </p>
            <p className="outfit-regular about-intro">
              I'm constantly learning, building, and exploring new technologies. Whether it's crafting beautiful user interfaces, 
              architecting robust backend systems, or training machine learning models, I bring dedication and creativity to every project. 
              When I'm not coding, you'll find me playing Chess or contributing to open-source communities.
            </p>
            <p className="outfit-regular about-intro">
              Let's build something amazing together! 🚀
            </p>
          </div>
        </div>
      </div>
      <img 
        src="./assets/arrow.png" 
        alt="Arrow icon" 
        className="icon arrow" 
        onClick={() => window.location.href = '#education'}
      />
    </section>
  );
}

export default About;
